import * as React from "react";
const Trophy = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 97 97", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 95, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M96 1H1v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M64.4 32.7H32.7v47.5h31.7z" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M72.2 80.2v-8.9H24.8v8.9H8.9V96h79.2V80.2z" }),
        React.createElement("path", { fill: "#ED0000", d: "M48.5 48.5C74.7 48.5 96 27.2 96 1H1c0 26.2 21.3 47.5 47.5 47.5" }))));
export default Trophy;
//# sourceMappingURL=Trophy.js.map